const columnConfig = [
  {
    title: 'ID',
    accessor: 'id',
    name: 'id',
    filterable: false,
    sortable: false,
    width: 50,
  },
  {
    title: 'drivers.driverCode',
    name: 'name',
    accessor: 'name',
    filterable: false,
    sortable: false,
  },
  {
    title: 'drivers.zones',
    name: 'zones',
    accessor: row => row.zones.length,
    filterable: false,
    sortable: false,
  },
];

export default columnConfig;
